import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { eventCashFlowInitialValues, IEventCashFlowForm } from 'components/organisms/forms/event-cash-flow/EventCashFlowForm';
import { FormikHelpers } from 'formik';
import { useCustomParamId } from 'hooks/useParamId';
import { eventCashFlowFormToUpdateQuery, eventCashFlowQueryToForm } from 'middleware/event-cash-flow';
import { useTranslation } from 'react-i18next';
import { PiReceiptFill, PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { useGetEventCost, useUpdateEventCost } from 'services/events/cost';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const EditEventCost = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const eventCostId = useCustomParamId('eventCostId');
  
  const updateEventCost = useUpdateEventCost();
  const { data: eventCost, isLoading } = useGetEventCost(eventCostId);

  const onEditEventCost = async (
    values: IEventCashFlowForm,
    helpers: FormikHelpers<IEventCashFlowForm>
  ) => {
    if (!eventCost) return;
    
    const eventCostData = eventCashFlowFormToUpdateQuery(values, 'cost', eventCost.id, eventCost.version) as any;
    
    await updateEventCost.mutateAsync(eventCostData, {
      onSuccess: () => {
        helpers.setSubmitting(false);
        navigate(`/event/${eventCost.eventId}/cost/${eventCostId}`);
      },
      onError: () => {
        helpers.setSubmitting(false);
      },
    });
  };

  return (
    <Form.EventCashFlow
      i18nextPrefix='event-cost'
      initialValues={
        eventCost ? eventCashFlowQueryToForm(eventCost, 'cost') : eventCashFlowInitialValues
      }
      onSubmit={onEditEventCost}
      status={{ isLoading }}
      customBackItem={
        <Button 
          type='button' 
          onlyIcon 
          onClick={() => navigate(`/event/${eventCost?.eventId}/cost/${eventCostId}`)}
        >
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.save')} />
          <Button.Icon icon={<PiReceiptFill />} />
        </Button>
      }
    />
  );
};

export default EditEventCost; 